import Header from './components/header/Header'
import fotojr1 from '../src/assets/fotojr1.jpg'
import './index.css'
import Card from './components/card/Card'
import ImageMain from './components/imageMain/ImageMain'
import Header2 from './components/header/Header2'
import SecondCard from './components/secondCard/SecondCard'
import SecondCard2 from './components/secondCard2/SecondCard2'
import Local from './components/local/Local'
import Folder from './components/Folder/Folder'
import Curriculo from './components/curriculo/Curriculo'
import Especialidades from './components/Especialidades/Especialidades'
import WhatsappImg from './components/whatsapp/Whatsapp'


function App() {
  return (
    <div>
      
      <Header2/> 
      <Folder/>      
      <SecondCard2/>
      <Curriculo/>  
      <Especialidades/>    
      <Local/>
      <WhatsappImg/>
      
    </div>
    
  );
}

export default App;
